<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <slot name="header"></slot>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <slot name="body"></slot>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <slot name="footer"></slot>
      </div>
     </div>
</div>
</div>
</template>

<script>
export default {
  props: ['isModalVisible'],
  methods: {
    closeModal() {
      this.$emit('close');
    }
  },
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}
.modal-container {
    width: 280px;
    margin: 40px auto 0;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
}
.modal-body {
    margin: 0px;
    padding: 10px;
}
@media(max-width:560px) {
  .modal-container {
    width: 98%;
    padding: 20px 20px;
  }
  .modal-body {
      margin: 0px;
      padding: 0px;
  }
}

.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
  border: 0px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.modal-footer {
  border-top: none;
}
.btn-info, .btn-info:hover, .btn-info:focus {
  background-color: #C3C3C3 !important;
  border: 1px solid #CCC !important;
  color: #000;
}
.btn {
  padding: 1px 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/mentee/answer-scale-modal.vue